import { api } from "../../api/http";

const BASE = "/api/backoffice/certifications/";

export async function listTalks(params = {}) {
	const res = await api.get(BASE, { params });
	return res.data;
}

export async function getTalk(id) {
	const res = await api.get(`${BASE}${id}/`);
	return res.data;
}

export async function createTalk(payload) {
	const res = await api.post(BASE, payload);
	return res.data;
}

export async function updateTalk(id, payload) {
	const res = await api.patch(`${BASE}${id}/`, payload);
	return res.data;
}

export async function deleteTalk(id) {
	const res = await api.delete(`${BASE}${id}/`);
	return res.data;
}

export async function listTalkParticipants(id) {
	const res = await api.get(`${BASE}${id}/participants/`);
	return res.data;
}

export async function importTalkParticipants(id, file) {
	const form = new FormData();
	form.append("file", file);
	const res = await api.post(`${BASE}${id}/import-participants/`, form);
	return res.data;
}

export async function generateTalkCertificates(id) {
	const res = await api.post(`${BASE}${id}/generate-certificates/`, null, {
		responseType: "blob",
	});
	return {
		blob: res.data,
		contentDisposition: res.headers["content-disposition"] || "",
	};
}

export async function downloadTalksTemplate() {
	const res = await api.get(`${BASE}download-template/`, {
		responseType: "blob",
	});
	return {
		blob: res.data,
		contentDisposition: res.headers["content-disposition"] || "",
	};
}
